import React from "react";
import { Flex, Text } from "@theorgchartdev/storybook";
import { QRulePair } from "@coreapp/CoreApp/QRulePair";
import { ConditionInput } from "./ConditionInput";
import { appstr } from "@coreapp/utils/appstr";
import { GetDoc } from "@/Utils/StateLib";
import { getComparisonLabel } from "@/appComponents/Blocks/Composites/RuleInput/RulePairInput/RulePairInput.util";

type Props = {
  rules: QRulePair[];
};

const RuleSummary = ({ rule }: { rule: QRulePair }) => {
  const doc = GetDoc();
  const fieldName = rule.GetFieldName() || "";
  const comparison = rule.GetComparison() || "";
  const fieldDef = rule.GetReferenceFieldDef?.(doc);
  const valueString = rule.GetValueDisplayString?.(doc) || "";
  const comparisonLabel = getComparisonLabel(
    comparison,
    rule.IsFieldToFieldComparison?.(),
    fieldDef as any
  );

  return (
    <Text size="small">
      {fieldName} <strong>{comparisonLabel}</strong> {valueString}
    </Text>
  );
};

export const ReadOnlyCriteriaList = ({ rules }: Props) => {
  if (!rules || rules.length === 0) return null;

  const orBlocks = QRulePair.SplitIntoOrBlocks(rules, false);

  return (
    <Flex direction="column">
      {orBlocks.map((orBlock, blockIndex) => {
        const orBlockLength = orBlock.length;
        const criteriaN = (ruleIndex: number) =>
          orBlockLength > 1 ? `${blockIndex + 1}.${ruleIndex + 1}` : `${blockIndex + 1}`;

        return (
          <React.Fragment key={blockIndex}>
            <div
              className={
                orBlockLength > 1 ? "ocn-filter-or-block-multiple" : "ocn-filter-or-block-single"
              }
            >
              {orBlock.map((rule: QRulePair, ruleIndex: number) => (
                <React.Fragment key={rule.fUID ?? ruleIndex}>
                  <div className="ocn-filter-criteria-card">
                    <Flex direction="column">
                      <div className="oc-filter-criteria-card-header oc-filter-criteria-card-header--readonly">
                        <Flex padding="8px 12px" alignItems="center">
                          <span className="ocn-type-body--medium">
                            {appstr("Entity i", {
                              entity: appstr("Criteria"),
                              i: criteriaN(ruleIndex)
                            })}
                          </span>
                        </Flex>
                      </div>
                      <Flex padding="8px 12px">
                        <RuleSummary rule={rule} />
                      </Flex>
                    </Flex>
                  </div>
                  {ruleIndex < orBlock.length - 1 && (
                    <Flex direction="row" margin="0 0 8px">
                      <ConditionInput isEditing={false} value={rule.fCondition} />
                    </Flex>
                  )}
                </React.Fragment>
              ))}
            </div>
            {blockIndex < orBlocks.length - 1 && (
              <Flex direction="row" margin="0 0 8px">
                <ConditionInput isEditing={false} value={orBlock[orBlock.length - 1].fCondition} />
              </Flex>
            )}
          </React.Fragment>
        );
      })}
    </Flex>
  );
};
